import { render, staticRenderFns } from "./SysProdutosAutocomplete.vue?vue&type=template&id=4691f109&scoped=true"
import script from "./SysProdutosAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./SysProdutosAutocomplete.vue?vue&type=script&setup=true&lang=js"
import style0 from "./SysProdutosAutocomplete.vue?vue&type=style&index=0&id=4691f109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4691f109",
  null
  
)

export default component.exports